import React, {useEffect, useRef, useState} from 'react';
import {IStringProps} from "../../../utils/cellInterfaces";
import {Dropdown} from 'primereact/dropdown';
import {Button} from 'primereact/button';
import {Dialog} from 'primereact/dialog';
import {InputTextarea} from 'primereact/inputtextarea';

export function String(props: IStringProps) {
    const [displayModal, setDisplayModal] = useState(false);
    const [position, setPosition] = useState('center');
    const [text, setText] = useState('');

    useEffect(() => {
        setText(props.value)
    }, [])

    const dialogTextChangeHandler = (value: string) => {
        setText(value);
    }

    // @ts-ignore
    const onClick = (name, position) => {
        setDisplayModal(true);
        if (position) {
            setPosition(position);
        }
    }

    const onHide = (name: string) => {
        setDisplayModal(false);
    }

    const onSave = (name: string) => {
        props.changeHandler(text);
        onHide(name);
    }

    const renderFooterEditable = (name: string) => {
        return (
            <div>
                <Button label="Save" icon="pi pi-check" onClick={() => onSave(name)} autoFocus/>
                <Button label="Close" icon="pi pi-times" onClick={() => onHide(name)} className="p-button-text"/>
            </div>
        );
    }

    const renderFooter = (name: string) => {
        return (
            <div>
                <Button label="Close" icon="pi pi-times" onClick={() => onHide(name)} className="p-button-text"/>
            </div>
        );
    }

    const showStart = () => {
        return props.value.substring(0, 6) + '...';
    }

    const myRef = useRef(null);

    const onClick2 = () => {
        if (myRef) {
            // @ts-ignore
            myRef.current.focus();
        }
    }

    const buttonStyle = {padding: '7px', width: '-webkit-fill-available', margin: '4px'};

    if (props.shortenText) {
        // if (false) {
        // TODO aprwappinti su dialog
        if (props.isInEditMode) {
            if (props.selectionValues && props.selectionValues.length > 0) {
                return <>
                    <Button label={showStart()} className='p-button-sm' style={buttonStyle} icon="pi pi-comment"
                            onClick={() => onClick('displayModal', undefined)}/>
                    <Dialog header="Message" visible={displayModal} modal={false} style={{width: 'auto'}} footer=
                        {renderFooterEditable('displayModal')} onHide={() => onHide('displayModal')}>
                        <Dropdown style={{width: '100%'}} value={props.value} options={props.selectionValues}
                                  placeholder={props.value} onChange={(e) => props.changeHandler(e.value)} required/>
                    </Dialog>
                </>
            } else {
                return <>
                    <Button label={showStart()} className='p-button-sm' style={buttonStyle} icon="pi pi-comment"
                            onClick={() => onClick('displayModal', undefined)}/>
                    <Dialog header="Message" visible={displayModal} modal={false} style={{width: 'auto'}} footer=
                        {renderFooterEditable('displayModal')} onHide={() => onHide('displayModal')}>
                        <InputTextarea value={text} onChange={(e) => dialogTextChangeHandler(e.target.value)} rows={5}
                                       cols={30} autoResize/>
                    </Dialog>
                </>
            }
        } else {
            return <>
                {
                    props.value.length > 0 &&
                    <>
                        <Button label={showStart()} className='p-button-sm' style={buttonStyle} icon="pi pi-comment"
                                onClick={() => onClick('displayModal', undefined)}/>
                        <Dialog header="Message" style={{width: '40vw'}} visible={displayModal} modal={false} footer=
                            {renderFooter('displayModal')} onHide={() => onHide('displayModal')}>
                            <div style={{wordWrap: 'break-word'}}>
                                {props.value + ' ' + props.unit}
                            </div>
                        </Dialog>
                    </>
                }
            </>
        }
    } else {
        if (props.isInEditMode) {
            if (props.selectionValues && props.selectionValues.length > 0) {
                return <Dropdown style={{width: '100%', textAlign: 'left'}} value={props.value}
                                 options={props.selectionValues} placeholder={props.value}
                                 onChange={(e) => props.changeHandler(e.value)} required/>
            } else {
                return <>
                    <div className="p-inputtext p-d-flex p-jc-between" style={{padding: '0'}}
                         onClick={() => onClick2()}>
                        <input ref={myRef} className="p-inputtext"
                               style={{border: 'none', float: 'left', width: '100%'}} value={props.value}
                               onChange={(e) => props.changeHandler(e.target.value)}
                        />
                        {
                            props.unit && props.unit.replaceAll(' ', '') && <label style={{padding: '12px'}}>
                                {' ' + props.unit}
                            </label>
                        }
                    </div>
                </>
            }
        } else {
            return <div className="p-inputtext"
                        style={{
                            border:"none",
                            backgroundColor: 'inherit',
                            color: "inherit",
                            whiteSpace: "pre-wrap"
                        }}>
                {!props.value && !props.unit &&
                    <>&#8203;</>
                }
                {props.value + ' ' + props.unit}
            </div>
        }
    }
}